import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class Privacy extends Page{
    constructor(){
        super({
            id : 'privacy',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}